
import { UserRoles } from '@/contexts/auth/enums';
import { User, PersonName } from '../types';

interface InitialAdminData {
  name: PersonName;
  email: string;
  password: string;
  companyName?: string;
  roles: UserRoles[];
}

export const checkInitialSetupRequired = async (): Promise<boolean> => {
  try {
    const API_URL = import.meta.env.VITE_APP_CONGNESS_API_URL as string;
    const response = await fetch(`${API_URL}/setup/check`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    // If there are no admin users, initial setup is required
    return data.setupRequired === true;
  } catch (error) {
    console.error('Setup check error:', error);
    // If we can't check, assume setup is not required to avoid blocking access
    return false;
  }
};

export const createInitialAdmin = async (adminData: InitialAdminData): Promise<{ success: boolean; message?: string; user?: User }> => {
  try {
    const API_URL = import.meta.env.VITE_APP_CONGNESS_API_URL as string;
    const response = await fetch(`${API_URL}/setup/init`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: adminData.email,
        plainPassword: adminData.password,
        userProfile: {
          '@id': '', // Will be assigned by the API
          name: adminData.name,
          companyName: adminData.companyName || ''
        },
        roles: adminData.roles
      })
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: data.message || "Nem sikerült létrehozni az admin fiókot."
      };
    }

    return {
      success: true,
      user: data.user
    };
  } catch (error) {
    console.error('Initial admin creation error:', error);
    return {
      success: false,
      message: "Kapcsolati hiba történt. Kérjük, próbálja újra később."
    };
  }
};
